import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'comment-icon',
  templateUrl: './comment-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CommentIconComponent {}
